import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer>
      <p>Contact Us: (224) 226-0693 | readymoverschicago@gmail.com</p>
      <p>© 2025 Ready Movers. All rights reserved.</p>
      <div className="footer-links">
        <Link to="/">Home</Link> | <Link to="/about">About</Link> |
        <Link to="/contact">Contact</Link>
      </div>
    </footer>
  );
}

export default Footer;
